<template>
  <th class="text-center" max-width="100px">
    <v-dialog v-model="dialog" max-width="400px" content-class="rounded-xl">
      <template v-slot:activator="{ on }">
        <v-btn fab x-small text v-on="on">
          <v-icon small>mdi-wrench</v-icon>
        </v-btn>
      </template>
      <v-card class="rounded-xl">
        <v-card-title>
          <span class="headline">Фильтр {{ name }}</span>
          <v-spacer></v-spacer>

          <v-btn icon @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-tabs fixed-tabs icons-and-text>
          <v-tab dense>
            Точное значение
            <v-icon left>mdi-bullseye-arrow</v-icon>
          </v-tab>
          <v-tab dense>
            Список
            <v-icon left> mdi-format-list-bulleted</v-icon>
          </v-tab>
          <v-tab-item>
            <v-card flat id="exact-coef">
              <v-card-text>
                <v-select
                  label="Точное значение"
                  clearable
                  @change="successClicked"
                  :items="fighters"
                  :menu-props="{
                    bottom: true,
                    offsetY: true,
                  }"
                  v-model="selected"
                ></v-select>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card id="range-coef">
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-select
                      label="Выбрано"
                      required
                      multiple
                      :menu-props="{
                        bottom: true,
                        offsetY: true,
                        maxWidth: 320,
                      }"
                      :items="fighters"
                      v-model="selectedMultiple"
                    ></v-select>
                  </v-row>
                  <v-row>
                    <v-checkbox
                      label="Исключить эти значения"
                      v-model="checkbox"
                    ></v-checkbox>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  fab
                  small
                  class="success"
                  :disabled="this.selectedMultiple.length == 0"
                  right
                  @click="successClickedMultiple"
                >
                  <v-icon>mdi-check</v-icon>
                </v-btn>

                <v-btn
                  fab
                  small
                  :disabled="this.selectedMultiple.length == 0"
                  class="error"
                  right
                  @click="discardClickedMultiple"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-tab-item>
        </v-tabs>
        <!-- <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn class="success" @click="successClicked">
            <v-icon>mdi-check</v-icon>
          </v-btn> -->
        <!-- <v-btn class="error" @click="dialog = false">
            <v-icon> mdi-close </v-icon>
          </v-btn> -->
        <!-- </v-card-actions> -->
      </v-card>
    </v-dialog>
  </th>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  props: {
    entity: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      dialog: false,
      selected: "",
      fighters: [
        "Бо Рай Чо",
        "Горо",
        "Джакс",
        "Джейсон Вурхиз",
        "Джонни Кейдж",
        "Джэки Бриггс",
        "Ди'Вора",
        "Кано",
        "Кенши",
        "Китана",
        "Кожаное лицо",
        "Коталь Кан",
        "Куан Чи",
        "Кунг Лао",
        "Кунг Джин",
        "Кэсси Кейдж",
        "Лю Кенг",
        "Милина",
        "Райдэн",
        "Рептилия",
        "Саб-Зиро",
        "Скорпион",
        "Соня Блейд",
        "Такеда Такахаши",
        "Таня",
        "Тремор",
        "Триборг",
        "Ферра и Торр",
        "Хищник",
        "Чужой",
        "Шиннок",
        "Эрмак",
        "Эррон Блэк",
      ],
      checkbox: false,
      selectedMultiple: [],
    };
  },
  methods: {
    ...mapActions(["setFilterKey", "deleteFilterKey", "getSettings"]),
    ...mapGetters(["getSettings"]),
    setFighter: function(fighter) {
      let key = this.entity + this.name;
      let value = fighter;
      this.updateForm(key, value);
    },
    successClicked: function () {
      // this.dialog = false;
      this.checkbox = false;
      this.selectedMultiple = [];
      var lookup = this.checkbox ? "__not_in" : "__in";
      let key_to_delete = this.entity + this.name + lookup;
      // console.log("Deleting: " + key_to_delete);
      this.cleanKey(key_to_delete);

      let key = this.entity + this.name;
      let value = this.selected;
      // console.log("Selected: " + value);

      this.updateForm(key, value);
    },
    successClickedMultiple: function () {
      // First clean other filters to avoid conflicts
      this.dialog = false;
      this.selected = "";
      var lookup = this.checkbox ? "__not_in" : "__in";
      var negative_lookup = lookup == "__not_in" ? "__in" : "__not_in";
      var key_to_delete = this.entity + this.name + negative_lookup;
      // console.log("Key to delete:" + key_to_delete);
      this.cleanKey(key_to_delete);
      key_to_delete = this.entity + this.name;
      this.cleanKey(key_to_delete);

      // Then updating form
      let key = this.entity + this.name + lookup;
      let value = this.selectedMultiple;
      // console.log("Selected: " + value);
      this.updateForm(key, value);
    },
    discardClickedMultiple: function () {
      this.selectedMultiple = [];
      this.checkbox = false;
      // this.selected = "";
      var lookup = this.checkbox ? "__not_in" : "__in";
      var negative_lookup = lookup == "__not_in" ? "__in" : "__not_in";
      var key_to_delete = this.entity + this.name + negative_lookup;
      // console.log("Key to delete:" + key_to_delete);
      this.cleanKey(key_to_delete);
      key_to_delete = this.entity + this.name;
      this.cleanKey(key_to_delete);

      // Then updating form
      let key = this.entity + this.name + lookup;
      let value = this.selectedMultiple;
      // console.log("Selected: " + value);
      this.updateForm(key, value);
    },

    cleanKey: function (key_to_delete) {
      this.deleteFilterKey({ key_to_delete });
    },

    updateForm: function (key, value) {
      this.setFilterKey({ key, value });
      this.$emit("filter_update");
    },
    findValueByPrefix: function (object, prefix) {
      for (var property in object) {
        if (
          Object.prototype.hasOwnProperty.call(object, property) &&
          property.toString().startsWith(prefix)
        ) {
          return [property, object[property]];
        }
      }
    },
  },
  created() {
    // console.log("Entity + name = " + this.entity + this.name);
    let prefix = this.entity + this.name;
    let settings = this.getSettings().filters;
    let result = this.findValueByPrefix(settings, prefix);
    // console.log("selectedMultiple: " + this.selectedMultiple);
    if (!result) {
      return;
    }
    let key = result[0];
    let value = result[1];
    // console.log("KEY: " + key + " VALUE: " + value);
    if (key.includes("in")) {
      // console.log("Includes IN");
      this.selectedMultiple = value;
      // console.log("Selected multiple: " + this.selectedMultiple);
    } else {
      this.selected = value;
    }
    if (key.includes("not")) {
      this.checkbox = true;
    }
    // this.selected = this.getSettings().filters[this.entity + this.name];
    // this.selectedMultiple = this.getSettings().filters[this.entity + this.name];
  },
};
</script>

<style scoped>
</style>
